module.exports = __webpack_public_path__ + "static/media/meme-3.878779c7.webp";